"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Offer = void 0;
var _reactCoolInview = require("react-cool-inview");
var _contexts = require("../../contexts");
var _OfferSkeleton = require("../OfferSkeleton");
var _components = require("./components");
var _jsxRuntime = require("react/jsx-runtime");
// istanbul ignore next -- not testable
const onEnter = (param)=>{
    let { unobserve } = param;
    unobserve();
};
/**
 * Component to render offer.
 * If offer has not entered the viewport, it will render a skeleton.
 * Otherwise it will render the offer content.
 */ const Offer = (param)=>{
    let { offer } = param;
    const { inView, observe } = (0, _reactCoolInview.useInView)({
        rootMargin: '100px',
        onEnter
    });
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        ref: observe,
        children: inView ? /*#__PURE__*/ // istanbul ignore next -- do not need to test this, all contents are tested separately
        (0, _jsxRuntime.jsx)(_contexts.OfferDetailProvider, {
            offer: offer,
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_components.OfferContent, {})
        }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_OfferSkeleton.OfferSkeleton, {})
    });
};
exports.Offer = Offer;
